export const Score = {
    "最终成绩":"Final score:",
    "原始成绩":"Original score:",
    "个人成绩":"Personal score",
    "占比":"ratio",
    "成绩未公布":"Scores not published",
    "未公布":"unpublished",
    "满分":"Full score",
    "纸":"P",
    "分数未公布":"Scores not published",
    "搜索学生名学号":"Search student name and ID",
    "修改":"Modify",
    "的成绩":"'s score",
    "满分100":"(Full score: 100)",
    "确认修改":"Confirm modification",
    "成绩不允许为空且不能超过100":"Score cannot be blank and cannot exceed 100",
    "成绩组成":"Composition of score",
    "占":"ratio",
    "的个人成绩":"'s personal score",
    "请输入成绩":"Please enter the score",
    "设置成绩":"Set grades",
    "排名":"Ranking",
    "课程考核标准":"Course assessment criteria",
    "暂时还没有总成绩记录":"No total score record yet",
    "我是学生":"I am a student",
    "成绩详情":"Grade Details",
    "最高分":"Highest score",
    "最低分":"Minimum score",
    "暂时还没有总成绩":"No total score yet",
    "请登录":"Please login",
    "wwwketangpaicom在电脑端设置添加":"www.ketangpai.com, set and add on the computer side",
    "电脑端在电脑端设置添加":"Computer side, set and add on the computer side",
    

}